import { Component, OnInit } from '@angular/core';
import { Unit } from '../unit';
import { Router,ActivatedRoute } from '@angular/router';
import { UnitService } from '../unit.service';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/observable';



@Component({
  selector: 'app-unit-crud',
  templateUrl: './unit-crud.component.html',
  styleUrls: ['./unit-crud.component.css'],
  providers: [UnitService]
})
export class UnitCrudComponent implements OnInit {

  id: any= null;
  units: Unit;
  msgs: Message[] = [];
  button_caption: string ="Сохранить"
  button_icon:string ="fa fa-save";
  panel_header_caption: string = "Регистрация единица измерения";
  loading: boolean = false;



  constructor(
              private location: Location,
              private unitService: UnitService,
              private router: Router,
              private activatedRoute: ActivatedRoute
              ) {
  	 activatedRoute.params.subscribe(params=>{this.id=params['id']});

   		  if(this.id){
          this.panel_header_caption = "Редактирования единица измерения";
          this.loading=true;   
   		  	this.unitService.getUnitById(this.id).subscribe(response=>{this.units=response['data'];this.loading=false;});	
   		 		this.button_caption="Редактировать";
   		 		this.button_icon="fa fa-edit";
   		  }

   }

  ngOnInit() {
  	this.units={
			id: "",
			name: "",
			available: true 
  	}
  }

   backClicked() {
        this.location.back();
  }  

   canDeactivate(): Observable<boolean> | boolean {
      return window.confirm('Discard changes?');
      // return false;
  }

  crud(form):void{

   		  if(!this.id){
            this.loading=true;   
   		  		this.unitService.createUnit(form.value)
   		  		.subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/unit']);}
                  , (error)=>{this.loading=false;});

   		  }else{
          this.loading=true;   
   		  	this.unitService.updateUnit(form.value,this.id)
   		  		.subscribe((data) => {this.loading=false;this.router.navigate(['/dashboard/unit']);}
                  , (error)=>{this.loading=false;});
   		  }
  }
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/units/unit-crud/unit-crud.component.ts